// Central API configuration for production & local deployment
export const API_BASE = process.env.REACT_APP_API_URL || (
    typeof window !== 'undefined' && window.location.protocol === 'https:'
        ? `${window.location.origin}/api`
        : `http://${typeof window !== 'undefined' ? window.location.hostname : 'localhost'}:5000/api`
);

export const SERVER_BASE = process.env.REACT_APP_SERVER_URL || (
    typeof window !== 'undefined' && window.location.protocol === 'https:'
        ? window.location.origin
        : `http://${typeof window !== 'undefined' ? window.location.hostname : 'localhost'}:5000`
);

export const FORENSICS_BASE = process.env.REACT_APP_FORENSICS_URL || (
    typeof window !== 'undefined' && window.location.protocol === 'https:'
        ? `${window.location.origin}/forensics`
        : `http://${typeof window !== 'undefined' ? window.location.hostname : 'localhost'}:8000`
);

export const DIGITAL_TWIN_BASE = process.env.REACT_APP_DIGITAL_TWIN_URL || (
    typeof window !== 'undefined' && window.location.protocol === 'https:'
        ? `${window.location.origin}/digital-twin-app`
        : `http://${typeof window !== 'undefined' ? window.location.hostname : 'localhost'}:5173`
);

export const DIGITAL_TWIN_API = process.env.REACT_APP_DIGITAL_TWIN_API_URL || (
    typeof window !== 'undefined' && window.location.protocol === 'https:'
        ? `${window.location.origin}/digital-twin-api`
        : `http://${typeof window !== 'undefined' ? window.location.hostname : 'localhost'}:3001`
);

export const DIGITAL_TWIN_GRAFANA = process.env.REACT_APP_DIGITAL_TWIN_GRAFANA_URL || (
    typeof window !== 'undefined' && window.location.protocol === 'https:'
        ? `${window.location.origin}/digital-twin-grafana`
        : `http://${typeof window !== 'undefined' ? window.location.hostname : 'localhost'}:3005`
);

